<div class="unsupported-browser-modal">
  <div class="unsupported-browser-modal__header">
    {{ "unsupported_browser.title" | translate }}
  </div>

  <div class="unsupported-browser-modal__body">
    {{ "unsupported_browser.text_1" | translate }}
    <a
      href="https://www.google.com/chrome/"
      rel="noopener"
      target="_blank"
      class="unsupported-browser-modal__body__link"
      >Google Chrome</a
    >
    {{ "unsupported_browser.text_3" | translate }}
  </div>

  <div class="unsupported-browser-modal__button">
    <app-button
      (appButtonClick)="dialogRef.close()"
      color="primary"
      type="raised-button"
      buttonTextTranslationKey="unsupported_browser.ok"
    ></app-button>
  </div>
</div>
